import React from 'react';
import { quoteWorksheetColumnPlan, QuoteWorksheetColumn } from './quoteWorksheetColumns';
import './quoteTemplateSendToClient/clientQuoteWorksheet.css';

/** Actuals/Invoice retain their own optional-column order with the approved Quote proportions. */
export default function DocumentEditorColumns({ options }: { options: any }) {
  const columns: QuoteWorksheetColumn[] = ['date', 'quantity', ...(options.includeArea ? ['area' as const] : []),
    'position', ...(options.includeToolsGear ? ['tools' as const] : []), 'call-time', 'notes', 'rate-type', 'call-type', 'meal', 'rate', 'st', 'ot', 'dt',
    ...(options.includePerDiem ? ['per-diem' as const] : []), ...(options.includeMiscFees ? ['misc' as const] : []), 'total'];
  return <colgroup data-pdf-exclude>{quoteWorksheetColumnPlan(columns).map(({ name, standardWidth, compactWidth }) =>
    <col key={name} data-quote-column={name} style={{ '--standard-width': standardWidth, '--compact-width': compactWidth } as React.CSSProperties} />)}</colgroup>;
}
